import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CheckboxStatusComponent } from './components/checkbox-status/checkbox-status.component';

@NgModule({
  imports: [CommonModule, MatCheckboxModule, ReactiveFormsModule, FormsModule],
  declarations: [CheckboxStatusComponent],
  exports: [CheckboxStatusComponent],
})
export class PortalDoVendedorUiCheckboxStatusModule {}
